import { Space, Stack, Text, Title } from '@mantine/core';
import { useIntl } from 'react-intl';

import { PageLoading } from '@/pages/PageLoading';
import { useClubTermsPage } from '@/pages/club/profile/terms/useClubTermsPage';
import { LBCompletionNotification, ScreenHeader } from '@/shared/modules';

export const ClubTermsPage = () => {
  const {
    state: { isLoading, progressItems, progress }
  } = useClubTermsPage();
  const { formatMessage } = useIntl();
  if (isLoading) return <PageLoading />;
  return (
    <div>
      <ScreenHeader />
      <Title>{formatMessage({ id: 'pages.clubTerms.title' })}</Title>
      <Space h={8} />
      <Text fz={14}>
        {formatMessage({ id: 'pages.clubTerms.description' })}
      </Text>
      <Space h={24} />
      <Stack gap={16}>
        {progress.isSuccess &&
          Object.entries(progressItems).map(([key, value], index) => (
            <LBCompletionNotification
              key={key}
              title={`${formatMessage({ id: 'commons.step' })} ${index + 1}`}
              value={value.data || 0}
              description={formatMessage({
                id: `pages.clubTerms.progressSteps.${key}`
              })}
              onNavigate={value.navigate}
            />
          ))}
      </Stack>
    </div>
  );
};
